import dayjs from "@v2/lib/dayjs";

const getDateFormat = (
  date: string,
  format: string = "YYYY/MM/DD",
  locale: string = "fa"
) => {
  return dayjs(date).locale(locale).format(format)
}

export default getDateFormat
